import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'animate.css/animate.min.css';
import '../css/trimmis.scss';
import { Link } from 'react-router'
import MobileMenu from './MobileMenu.js';
import Bubbles from './Bubbles.js';
import Breakpoints from '../utils/breakpoints'
import Dimensions from 'react-dimensions'

class TrimmisHeader extends Component {

  constructor (props, context) {
    super(props, context);
    this.state = {
      goFixedAt: 0,
      marginTopFixed: this.props.marginTopForFixed,
      position: this.props.normalClass,
      menuOpen: false
    };
    this.listenScrollEvent = this.listenScrollEvent.bind(this);
  }

  componentDidMount() {
    if (!this.props.noScroll)
      window.addEventListener('scroll', this.listenScrollEvent);
    this.setState({
      goFixedAt: document.getElementsByClassName('trimmis-main-container')[0]
    });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenScrollEvent);
  }

  listenScrollEvent(){
    if (window.innerWidth >= Breakpoints.mobileScreenWidth){
      this.setState({
        position: this.state.goFixedAt.getBoundingClientRect().top>this.state.marginTopFixed ? this.props.normalClass : this.props.fixedClass
      });
    }
  }

  getMobileStyles(){
    let smallBreakpoint = Breakpoints.mobileScreenWidth;
    let elementWidth = window.innerWidth;
    return elementWidth <= smallBreakpoint ? {width: elementWidth+'px'} : {};
  }

  toggleOpen () {
    this.setState({
      menuOpen: !this.state.menuOpen
    });
  }

  mouseEnter(){
    this.setState({
      hovering: true
    });
  }
  mouseLeave(){
    this.setState({
      hovering: false
    });
  }

  render() {
    const menuItems = [
      {
        text: "Palvelut", link: "#",
      },
      {
        text: "Salongit", link: "#",
      },
      {
        text: "Liity joukkoomme", link: "#",
      },
      {
        text: "Blogi", link: "#",
      },
    ];

    return (
        <div className={this.state.position} onScroll={this.listenScrollEvent} style={this.getMobileStyles()}>
          <div className="col-sm-6 hidden-sm hidden-xs">
            <Link to={"/book-time"} className="trimmis-button col-sm-8 pull-right" onMouseEnter={ () => this.mouseEnter() } onMouseLeave={ () => this.mouseLeave() }>VARAA AIKA
              <Bubbles visible={this.state.hovering}/>
            </Link>
          </div>
          <div className="trimmis-menu-item-container col-sm-6 hidden-sm hidden-xs">
            <div className="pull-left">
              <Link to={"#"} className="trimmis-menu-item">tai soita 09 123 12345</Link>
            </div>
            <div className="pull-right">
              {menuItems.map((object, i) => {
                return <Link key={i} className="trimmis-menu-item" to={object.link}>{object.text}</Link>
              })}
            </div>
          </div>
          <div className="trimmis-hamburger-menu"> <i className="glyphicon glyphicon-menu-hamburger" onClick={() => this.toggleOpen()}></i></div>
          <div className="trimmis-mobile-menu-button"> <Link to={"/book-time"} className="trimmis-button">VARAA AIKA</Link></div>
          <MobileMenu menuItems={menuItems} toggleWith={this.state.menuOpen} closeMenu={() => this.toggleOpen()}/>
        </div>
    );
  }
}

export default Dimensions()(TrimmisHeader);



// WEBPACK FOOTER //
// ../components/TrimmisHeader.js